<section>
	@if (!isMailReply) {
		<custom-select [label]="'task-action.mail.templates' | translate" [placeholder]="'task-action.mail.templates-placeholder' | translate"
					   [selectList]="mailTemplatesList"
					   (valueChange)="changeMailTemplate($event)" />
	}

	@if (isMailReply) {
		<div span-columns>{{ mailData.recipients?.join('; ') }}</div>
	}
	@else {
		<add-multiple (selectedItemsChange)="recipientsChanged($event)"
					  [availableItems]="contactMails"
					  [emitNewValues]="true"
					  [validation]="validationTypeEnum.Email"
					  [required]="true"
					  [label]="'task-action.mail.recipients' | translate"
					  [placeholder]="'task-action.mail.recipients-placeholder' | translate" />
	}

	<div>
		@if (isMailReply) {
			<div>{{ mailData.subject }}</div>
		}
		@else {
			<custom-input [inputType]="inputTypeEnum.Text" [(value)]="mailData.subject" [label]="'task-action.mail.subject' | translate" [placeholder]="'task-action.mail.subject-placeholder' | translate" [required]="true" />
		}
	</div>
	<div>
		{{ getTrackingCode() }}
	</div>

	@if (signatureLoaded) {
		<custom-input [label]="'task-action.mail.content' | translate" [(value)]="mailData.comment" [inputType]="inputTypeEnum.Editor" [required]="true" />
	}
</section>
